import { buildStaffMenu } from "./staffMenu"
// Also available for CENTER_ADMIN-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Center Admin role menu — cloned from the shared staff (LXO-derived) base.
 *
 * Currently mirrors the staff base exactly. To add Center Admin-specific
 * overrides without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildCenterAdminMenu = () => buildStaffMenu()
